/*
  Kleine Zustandsanzeige für Lade-, Fehler- und Leerzustände.
*/

import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function ShiftplanV2State({ tone = "neutral", title, text, isLoading = false }) {
  return (
    <Box className={`spv2-state spv2-state--${tone}`}>
      {isLoading ? <CircularProgress size={22} thickness={5} /> : null}
      <Box className="spv2-state-copy">
        <Typography className="spv2-state-title">{title}</Typography>
        {text ? <Typography className="spv2-state-text">{text}</Typography> : null}
      </Box>
    </Box>
  );
}
